import { useCurrentStateAndParams } from '@uirouter/react';
import { ORION_CHAT_STATE_NAMES, resolveUnavailableTooltip } from './constants';
import { useAiEnabled } from 'ui/state/hooks/ai-enabled.hook';

export const useIsOrionChatAccount = (): boolean => useAiEnabled();

export const useIsOrionChatAllowedPage = (): boolean => {
  const {
    state: { name: stateName },
  } = useCurrentStateAndParams();

  return ORION_CHAT_STATE_NAMES.includes(stateName ?? '');
};

interface IOrionChatTriggerState {
  isAllowedPage: boolean;
  /** The matched ui-router state name — a route PATTERN, never a resolved URL. */
  stateName: string;
  /** `undefined` on an allowed page — the button is enabled and needs no explanation. */
  tooltip?: string;
}

export const useOrionChatTriggerState = (): IOrionChatTriggerState => {
  const {
    state: { name: stateName },
  } = useCurrentStateAndParams();
  const name = stateName ?? '';
  const isAllowedPage = ORION_CHAT_STATE_NAMES.includes(name);

  return { isAllowedPage, stateName: name, tooltip: isAllowedPage ? undefined : resolveUnavailableTooltip(stateName) };
};
